class NotificationBanner {
	currentBannerHash = '';

	init() {
		const notificationBanner = document.getElementById('notification-banner') as HTMLElement;
		if (notificationBanner) {
			const notificationBannerContent = notificationBanner.querySelectorAll(
				'.main-header-banner__action'
			) as NodeListOf<HTMLElement>;
			let stringToHash = '';
			notificationBannerContent.forEach((el) => {
				stringToHash = stringToHash + el.innerHTML;
			});
			this.currentBannerHash = this.createHash(stringToHash).toString();

			let bannerVisible = localStorage.getItem('bannerVisible');
			if (null === bannerVisible) {
				localStorage.setItem('bannerVisible', '1');
				bannerVisible = '1';
			}

			if ('1' === bannerVisible) {
				// event listener for close click
				const bannerClose = document.querySelectorAll(
					'.main-header-banner__close'
				) as NodeListOf<HTMLElement>;
				bannerClose.forEach((el) => {
					el.addEventListener('click', () => {
						this.setHideBanner();
					});
				});
			} else if (false === this.bannerShouldBeHidden()) {
				this.setShowBanner();
			} else {
				this.hideBanner();
			}
		}
	}

	bannerShouldBeHidden() {
		// should be visible based on time?
		const bannerReappear = localStorage.getItem('bannerReappear');
		const dateNow = Date.now();
		if (null === bannerReappear || parseInt(bannerReappear) <= dateNow) {
			return false;
		}

		// Should be visible based on changed content?
		const bannerHash = localStorage.getItem('bannerHash'); // hashed content
		if (null === bannerHash || bannerHash !== this.currentBannerHash) {
			return false;
		}

		return true;
	}

	setShowBanner() {
		localStorage.setItem('bannerVisible', '1');
		localStorage.removeItem('bannerReappear');
		localStorage.removeItem('bannerHash');
	}

	setHideBanner() {
		const dateNow = Date.now();
		const oneDay = 1000 * 60 * 60 * 24;
		const bannerReappear = dateNow + oneDay;

		localStorage.setItem('bannerVisible', '0');
		localStorage.setItem('bannerReappear', bannerReappear.toString());
		localStorage.setItem('bannerHash', this.currentBannerHash);
	}

	hideBanner() {
		const notificationBanner = document.getElementById('notification-banner') as HTMLElement;
		const notificationBannerClose = notificationBanner.querySelectorAll(
			'.main-header-banner__close'
		) as NodeListOf<HTMLElement>;
		notificationBanner.setAttribute('aria-expanded', 'false');
		notificationBannerClose.forEach((el) => {
			el.setAttribute('aria-expanded', 'false');
		});
	}

	createHash(string: string) {
		let hash = 0;

		if (string.length === 0) return hash;

		for (let i = 0; i < string.length; i++) {
			const char = string.charCodeAt(i);
			// eslint-disable-next-line no-bitwise
			hash = (hash << 5) - hash + char;
			// eslint-disable-next-line no-bitwise
			hash = hash & hash;
		}

		return hash;
	}
}

export default new NotificationBanner();
